"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.runPromisesSerially = runPromisesSerially;
function runPromisesSerially(actions, isSuccess) {
  if (actions.length < 1) {
    return Promise.resolve([]);
  }
  const results = [];
  return new Promise((resolve, reject) => {
    runPromisesSeriallyInner(actions, isSuccess, 0, results).then(resolve).catch(reject);
  });
}
function runPromisesSeriallyInner(actions, isSuccess, index, results) {
  const head = actions[index];
  const hasTail = index < actions.length - 1;
  return new Promise((resolve, reject) => {
    const {
      action,
      name
    } = head || {};
    if (!action || !name) {
      return reject(`The promise at index ${index} is not properly defined.`);
    }
    const rejectHandler = rejectPromise(name, index, results, reject);
    action(results).then(result => {
      results.push({
        name,
        index,
        result
      });
      if (isSuccess(result)) {
        if (!hasTail) {
          resolve(results);
        } else {
          runPromisesSeriallyInner(actions, isSuccess, index + 1, [...results]).then(rx => {
            resolve(rx);
          }).catch(rejectHandler);
        }
      } else {
        resolve(results);
      }
    }).catch(rejectHandler);
  });
}
const errorCtor = new Error().constructor;
function rejectPromise(name, index, response, reject) {
  return err => {
    if (err.detail) {
      reject(err);
    } else {
      if (err.constructor === errorCtor) {
        const {
          message,
          name
        } = err;
        err = {
          name,
          message
        };
      }
      const data = {
        name,
        index,
        detail: err,
        response
      };
      reject(data);
    }
  };
}